import {InsertDriveFileOutlined} from '@mui/icons-material';
import {Checkbox, TextField} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BackButton, Button, Container, Text, Title} from '../../components/@FreeModel';
import {contractSign, gql, queryApplicationWithContracts} from "../../db/model";
import {useDispatch, useSelector} from "react-redux";
import {selectApplication} from "../../db/selectors";
import {Mixpanel} from "../../observability/Mixpanel";

const TaxInfoReview = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)

  const [signature, setSignature] = useState('');
  const [address, setAddress] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const isValid = signature !== '' && agreedToTerms

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplicationWithContracts,
      variables: {id: applicationID},
      onSuccess: (data) => {
        const address = data.application?.address ?? {}
        setAddress(
          `${address.street1 ?? ''}${address.street2 ? ` ${address.street2}` : ''}, ${address.city ?? ''}, ${address.state ?? ''} ${address.postalCode ?? ''}`
        );
      }
    }))
  }, [dispatch, applicationID, setAddress]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: contractSign,
      variables: {
        applicationID: applicationID,
        signatureName: signature,
      },
      onSuccess: (_) => {
        Mixpanel.track("contractor-agreement-signed", {
          "invitation": applicationID,
        })
        navigate(`/contractors/${applicationID}/steps`)
      }
    }))
  };

  return (
    <Container className="tax-info-review">
      <Title color="orange" weight="bold" size="sm" lineHeight="sm">
        GETTING STARTED
      </Title>
      <Title weight="bold" size="xl" lineHeight="lg">
        Add Tax Info
      </Title>

      <BackButton to={`/contractors/${applicationID}/tax-info/individual/social-security`}/>

      <br/>
      <Text weight="semibold">Review the information and sign below to confirm and accept the following:</Text>

      <div className="tax-review-icon-link">
        <Text weight="semibold">
          Taxpayer Identification (Form W-9)
        </Text>
      </div>

      <ul>
        <li>{application.businessLegalName}</li>
        <li>{address}</li>
      </ul>

      <a href={`/contractors/${applicationID}/documents/contractor-agreement`}
         style={{textDecoration: "none", color: "inherit"}}>
        <div className="tax-review-icon-link">
          <InsertDriveFileOutlined className="tax-review-icon"/>
          <Text color="blue" weight="semibold">
            Freemodel Contractor Agreement
          </Text>
        </div>
        <ul>
          <li>
            You agree to maintain all required license(s) and insurance coverage
          </li>
          <li>
            All work must be defect-free, meet applicable building code and government regulations, and is subject to
            applicable warranties
          </li>
          <li>
            Payment will be made based on agreed upon amounts, project completion milestones, and applicable lien
            releases
          </li>
        </ul>
        <br/>
      </a>
      <form onSubmit={handleSubmit} className="tax-info-signature">
        <div className="signature-white">
          <input
            id="tax-signature"
            type="text"
            value={signature}
            placeholder="Enter your name below"
            disabled
          />

          <TextField
            style={{width: '100%'}}
            id="tax-full-name"
            variant="standard"
            label="Your full name"
            value={signature}
            onChange={e => setSignature(e.target.value)}
          />
        </div>

        <div className="tax-info-signature-check">
          <Checkbox
            id="tax-agree"
            className="tax-agree"
            checked={agreedToTerms}
            onChange={e => setAgreedToTerms(e.target.checked)}
            required
          />
          <label htmlFor="tax-agree">
            I understand this constitutes a legal signature confirming that I have read and agree to the terms in the
            above documents.
          </label>
        </div>

        <br/>

        <Button disabled={!isValid}>Agree & Sign</Button>
      </form>
    </Container>
  );
};

export default TaxInfoReview;
